<template>
  <Layout>
    <PageHeader :title="title" :items="items"></PageHeader>
    <div class="row" id="promotion">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row align-items-center mb-4">
              <div class="col-md-6">
                <div class="form-inline navbar-search">
                  <div class="input-group">
                    <input name="title" class="form-control bg-light border-0 small" placeholder="Search..."
                      aria-label="Search" aria-describedby="basic-addon2" value="" v-model="filter"
                      v-on:keyup="search" />
                    <div class="input-group-append">
                      <button class="btn btn-search" @click="searchFor">
                        <i class="fas fa-search fa-sm"> </i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
              <div class="all-tabs">
                <div
                  :class="activeTab == 'all' ? ' tab-options' : ''"
                  @click.prevent="fetchData('all')"
                  class="mx-2 opt"
                >
                  All
                </div>
                |
                <div
                  :class="activeTab == 'active' ? ' tab-options' : ''"
                  @click.prevent="fetchData('active')"
                  class="mx-2 opt"
                >
                  Active
                </div>
              </div>
            </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table striped bordered :items="tableData.data" :fields="fields" :sort-by.sync="sortBy" :per-page="0"
                :current-page="currentPage" :sort-desc.sync="sortDesc" :filter-included-fields="filterOn"
                @filtered="onFiltered" responsive="sm" class="table-bordered table-hover" :key="key">
                <template #cell(doctor_name)="data">
                  <a :href="data.item.profile_link" class="text-blue-600 hover:underline" target="_blank">
                    {{ data.item.doctor_name }}
                  </a>
                </template>
                <!-- <template v-if="can('edit-diet-plan')" v-slot:cell(edit)="row">
                  <div :class="{ 'disabled-link': row.item.status !== 'created' }">
                    <router-link :to="{
                      name: 'edit-diet-plan',
                      params: { id: row.item.id },
                    }">
                      <i class="fa fa-edit edit-i"></i>
                    </router-link>
                  </div>
                </template> -->
                <!-- <template can="'update-diet-plan-status'" v-slot:cell(gen_plan_status)="row">
                    <div class="text">
                        <b-button
                        v-if="row.item.status === 'processing'"
                        variant="primary"
                        size="md"
                        @click="updateStatus(row.item)"
                        >
                        {{ loadingId === row.item.id ? 'Generating...' : 'Generate Diet Plan' }}
                        </b-button>
                    </div>
                </template> -->
                <template can="'update-diet-plan-status'" v-slot:cell(gen_plan_status)="row">
                  <div class="text">
                    <!-- Show button only if status = processing -->
                    <b-button v-if="row.item.status === 'processing'" variant="primary" size="sm"
                      :disabled="loadingId === row.item.id" @click="updateStatus(row.item)">
                      {{ loadingId === row.item.id ? 'Generating...' : 'Generate Diet Plan' }}
                    </b-button>

                    <!-- Optional: Show text after generating -->
                    <!-- <span v-else-if="row.item.status === 'created'">✅ Diet plan generated</span> -->
                    <!-- Show link if diet plan is created and pdf_url exists -->
                    <div v-else-if="row.item.status == 'created' && row.item.pdf_url">
                      ✅ Diet plan generated
                      <a :href="row.item.pdf_url" target="_blank" rel="noopener noreferrer" class="ml-2 text-primary">
                        View PDF
                      </a>
                    </div>

                    <div v-else-if="row.item.status == 'created' && row.item.file_name">
                      ✅ Diet plan generated
                      <a :href="row.item.file_name" target="_blank" rel="noopener noreferrer" class="ml-2 text-primary">
                        View PDF
                      </a>
                    </div>

                    <!-- Optional: fallback if created but no PDF -->
                    <div v-else-if="row.item.status === 'created' && !row.item.pdf_url">
                      ✅ Diet plan generated (No PDF available)
                    </div>
                  </div>
                  <b-button v-if="row.item.account_id" class="mt-2" size="sm" variant="primary" @click="openLinkAccountModal(row.item.account_id)">
                    Update Link Account
                  </b-button>
                  <b-button 
                      v-if="row.item.stakeholder_id"
                      class="mt-2 ml-2" 
                      size="sm" 
                      variant="primary" 
                      @click="openChatModal(row.item.member_id,row.item.account_id,row.item.stakeholder_id)"
                  >
                      Update Stakeholder Account
                  </b-button>

                  <b-button v-if="row.item.account_product_id" class="mt-2 ml-2" size="sm" variant="primary" @click="updateProductConfig(row.item.member_id,row.item.account_id,row.item.account_product_id)">
                    Update Product Configuration
                  </b-button>
                </template>

                <template v-slot:cell(status)="row">
                  <div v-if="row.item.status == 'processing'">
                    <span class="p-1 badge badge-warning">Processing</span>
                  </div>
                  <div v-if="row.item.status == 'created' && row.item.file_name">
                    <span class="p-1 badge badge-success">Created</span>
                  </div>
                </template>
                <!-- <template v-can="'update-diet-plan-status'" v-slot:cell(is_approved)="row">
                  <b-form-checkbox switch class="mb-1" @change="updateApproveStatus(row.item.id)"
                    :checked="row.item.is_approved == 1 ? true : false" :disabled="row.item.status !== 'created'">
                  </b-form-checkbox>
                </template> -->
                  <template v-slot:cell(is_account)="row">
                      <b-form-checkbox
                          switch
                          class="mb-1"
                          :checked="row.item.is_account == 1"
                          disabled
                      ></b-form-checkbox>
                  </template>

                  <template v-slot:cell(is_stakeholder)="row">
                      <b-form-checkbox
                          switch
                          class="mb-1"
                          :checked="row.item.is_stakeholder == 1"
                          disabled
                      ></b-form-checkbox>
                  </template>
                  <template v-slot:cell(is_tnc)="row">
                      <b-form-checkbox
                          switch
                          class="mb-1"
                          :checked="row.item.is_tnc == 1"
                          disabled
                      ></b-form-checkbox>
                  </template>
                  <template v-can="'update-razorpay-vendor-status'" v-slot:cell(is_active)="row">
                      <b-form-checkbox
                          switch
                          class="mb-1"
                          @change="updateStatus(row.item.id)"
                          :checked="row.item.is_active == 1 ? true : false"
                      ></b-form-checkbox>
                  </template>
              </b-table>
              <b-modal
                  id="update-linked-account"
                  title="Update Linked Account"
                  size="xl"
                  centered
                  hide-footer
                  autocomplete="off"
                  >
                  <!-- <b-form @submit.prevent="submitUpdate"> -->
                      <div class="row">

                      <!-- BASIC INFO -->
                      <div class="col-12 mb-3">
                          <h5 class="section-title">Basic Information</h5>
                      </div>

                      <!-- <div class="col-md-6">
                          <b-form-group label="Business Email *">
                          <b-form-input v-model="form.email" required placeholder="example@email.com" />
                          </b-form-group>
                      </div>

                      <div class="col-md-6">
                          <b-form-group label="Business Phone *">
                          <b-form-input v-model="form.phone" type="number" required placeholder="10–15 digits" />
                          </b-form-group>
                      </div> -->

                      <div class="col-md-6">
                          <b-form-group>
                            <label for="Leagal Business Name"
                              >Leagal Business Name <span style="color: red">*</span></label
                            >
                          <b-form-input autocomplete="off" v-model="form.legal_business_name" required placeholder="Acme Corporation" />
                          </b-form-group>
                      </div>

                      <!-- <div class="col-md-6">
                          <b-form-group label="Customer Facing Business Name">
                          <b-form-input v-model="form.customer_facing_business_name" placeholder="Billing Label" />
                          </b-form-group>
                      </div> -->

                      <!-- <div class="col-md-6">
                          <b-form-group label="Business Type *">
                          <b-form-select
                              v-model="form.business_type"
                              :options="businessTypes"
                              required
                          />
                          </b-form-group>
                      </div> -->

                      <!-- <div class="col-md-6">
                          <b-form-group label="Reference ID">
                          <b-form-input v-model="form.reference_id" placeholder="External reference" />
                          </b-form-group>
                      </div> -->

                      <!-- PROFILE -->
                      <!-- <div class="col-12 mt-4 mb-2">
                          <h5 class="section-title">Business Profile</h5>
                      </div> -->

                      <!-- <div class="col-md-6">
                          <b-form-group label="Category *">
                              <b-form-select
                                  v-model="form.profile.category"
                                  :options="categories"
                                  required
                              />
                          </b-form-group>
                      </div>

                      <div class="col-md-6">
                          <b-form-group label="Subcategory *">
                              <b-form-select
                                  v-model="form.profile.subcategory"
                                  :options="filteredSubcategories"
                                  :disabled="!form.profile.category"
                                  required
                              />
                          </b-form-group>
                      </div> -->

                      <!-- <div class="col-md-4">
                          <b-form-group label="Business Model">
                          <b-form-input v-model="form.profile.business_model" placeholder="Short business description" />
                          </b-form-group>
                      </div> -->

                      <!-- ADDRESSES -->
                      <div class="col-12 mt-4 mb-2">
                          <h5 class="section-title">Address Information</h5>
                      </div>

                      <!-- REGISTERED ADDRESS -->
                      <div class="col-12"><h6 class="font-weight-bold">Registered Address <span style="color: red">*</span></h6></div>

                      <div class="col-md-4">
                          <b-form-group>
                            <label for="Address Line 1"
                              >Address Line 1 <span style="color: red">*</span></label
                            >
                          <b-form-input autocomplete="off" v-model="form.addresses.registered.address_line1" required />
                          </b-form-group>
                      </div>

                      <div class="col-md-4">
                          <b-form-group>
                            <label for="Address Line 2"
                              >Address Line 2 <span style="color: red">*</span></label
                            >
                          <b-form-input autocomplete="off" v-model="form.addresses.registered.address_line2" />
                          </b-form-group>
                      </div>

                      <div class="col-md-4">
                          <b-form-group>
                            <label for="City"
                              >City <span style="color: red">*</span></label
                            >
                          <b-form-input autocomplete="off" @keypress="allowOnlyText" v-model="form.addresses.registered.city" required />
                          </b-form-group>
                      </div>

                      <div class="col-md-4">
                          <b-form-group>
                            <label for="State"
                              >State <span style="color: red">*</span></label
                            >
                          <b-form-input autocomplete="off" @keypress="allowOnlyText" v-model="form.addresses.registered.state" required />
                          </b-form-group>
                      </div>

                      <!-- <div class="col-md-4">
                          <b-form-group label="Country *">
                          <b-form-input v-model="form.addresses.registered.country" required />
                          </b-form-group>
                      </div> -->

                      <div class="col-md-4">
                          <b-form-group>
                            <label for="Pincode"
                              >Pincode <span style="color: red">*</span></label
                            >
                          <b-form-input autocomplete="off" @keypress="allowOnlyNumbers" v-model="form.addresses.registered.pincode" :maxlength="6" />
                          </b-form-group>
                      </div>

                      <!-- OPERATIONAL ADDRESS -->
                      <!-- <div class="col-12 mt-3">
                          <h6 class="font-weight-bold">Operational Address</h6>
                      </div>

                      <div class="col-md-4">
                          <b-form-group label="Address Line 1">
                          <b-form-input v-model="form.addresses.operation.address_line1" />
                          </b-form-group>
                      </div>

                      <div class="col-md-4">
                          <b-form-group label="Address Line 2">
                          <b-form-input v-model="form.addresses.operation.address_line2" />
                          </b-form-group>
                      </div>

                      <div class="col-md-4">
                          <b-form-group label="City">
                          <b-form-input v-model="form.addresses.operation.city" />
                          </b-form-group>
                      </div>

                      <div class="col-md-4">
                          <b-form-group label="State">
                          <b-form-input v-model="form.addresses.operation.state" />
                          </b-form-group>
                      </div>

                      <div class="col-md-4">
                          <b-form-group label="Country">
                          <b-form-input v-model="form.addresses.operation.country" />
                          </b-form-group>
                      </div>

                      <div class="col-md-4">
                          <b-form-group label="Pincode">
                          <b-form-input v-model="form.addresses.operation.pincode" />
                          </b-form-group>
                      </div> -->

                      <!-- LEGAL INFO -->
                      <div class="col-12 mt-4 mb-2">
                          <h5 class="section-title">Legal Information (KYC)</h5>
                      </div>

                      <div class="col-md-6" v-if="!['individual', 'proprietorship', 'not_yet_registered', 'educational_institutes'].includes(form.business_type)">
                          <b-form-group>
                            <label for="Pan Card Number"
                              >Business Pan Card Number <span style="color: red">*</span></label
                            >
                          <b-form-input autocomplete="off" v-model="form.business_pan" placeholder="ABCDE1234F" />
                          </b-form-group>
                      </div>

                      <div class="col-md-6">
                          <b-form-group label="GST Number">
                            <!-- <label for="GST Number"
                              >GST Number <span style="color: red">*</span></label
                            > -->
                          <b-form-input autocomplete="off" v-model="form.gst" />
                          </b-form-group>
                      </div>

                      <div class="col-md-6">
                          <b-form-group>
                            <label for="Split Value"
                              >Split Value <span style="color: red">*</span></label
                            >
                          <b-form-input autocomplete="off" @keypress="allowDecimal"
                          @paste="allowDecimalPaste" v-model="form.split_value" />
                          </b-form-group>
                      </div>

                      <div class="col-md-6">
                          <b-form-group>
                            <label for="Split Type"
                              >Split Type <span style="color: red">*</span></label
                            >
                          <!-- <b-form-input v-model="form.split_type" placeholder="22ABCDE1234F1Z5" /> -->
                          <b-form-select
                            v-model="form.split_type"
                            :options="[
                              { value: 'fixed', text: 'Fixed' },
                              { value: 'percentage', text: 'Percentage' }
                            ]"
                          ></b-form-select>
                          </b-form-group>
                      </div>

                      </div>

                      <!-- ACTION BUTTONS -->
                      <div class="d-flex justify-content-end mt-3">
                      <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('update-linked-account')">
                          Cancel
                      </b-button>
                      <b-button variant="primary" @click="updateLinkedAccount">Update Linked Account</b-button>
                      </div>

                  <!-- </b-form> -->
              </b-modal>


              <b-modal
                  id="update-stakeholder-modal"
                  title="Update Stakeholder"
                  size="xl"
                  centered
                  hide-footer
                  >
                  <!-- <b-form @submit.prevent="submitStakeholderUpdate"> -->
                      <div class="row">

                      <!-- BASIC INFORMATION -->
                      <div class="col-12 mb-3">
                          <h5 class="section-title">Stakeholder Information</h5>
                      </div>

                      <!-- <div class="col-md-6">
                          <b-form-group label="Name (as per PAN) *">
                          <b-form-input
                              v-model="form1.name"
                              required
                              maxlength="255"
                              placeholder="Full Name"
                          />
                          </b-form-group>
                      </div>

                      <div class="col-md-6">
                          <b-form-group label="Email *">
                          <b-form-input
                              v-model="form1.email"
                              required
                              type="email"
                              placeholder="name@example.com"
                          />
                          </b-form-group>
                      </div> -->

                      <!-- <div class="col-md-4">
                          <b-form-group label="Percentage Ownership">
                          <b-form-input
                              v-model="form1.percentage_ownership"
                              type="number"
                              step="0.01"
                              max="100"
                              placeholder="87.55"
                          />
                          </b-form-group>
                      </div> -->

                      <!-- RELATIONSHIP -->
                      <!-- <div class="col-12 mt-4 mb-2">
                          <h5 class="section-title">Relationship With Business</h5>
                      </div>

                      <div class="col-md-6">
                          <b-form-checkbox v-model="form1.relationship.director" switch>
                          Director
                          </b-form-checkbox>
                      </div>

                      <div class="col-md-6">
                          <b-form-checkbox v-model="form1.relationship.executive" switch>
                          Executive
                          </b-form-checkbox>
                      </div> -->

                      <!-- PHONE -->
                      <!-- <div class="col-12 mt-4 mb-2">
                          <h5 class="section-title">Phone Numbers</h5>
                      </div>

                      <div class="col-md-6">
                          <b-form-group label="Primary Phone *">
                          <b-form-input
                              v-model="form1.phone.primary"
                              type="number"
                              required
                              placeholder="8–11 digits"
                          />
                          </b-form-group>
                      </div>

                      <div class="col-md-6">
                          <b-form-group label="Secondary Phone">
                          <b-form-input
                              v-model="form1.phone.secondary"
                              type="number"
                              placeholder="Optional"
                          />
                          </b-form-group>
                      </div> -->

                      <!-- RESIDENTIAL ADDRESS -->
                      <div class="col-12 mt-4 mb-2">
                          <h5 class="section-title">Residential Address</h5>
                      </div>

                      <div class="col-md-6">
                          <b-form-group>
                            <label for="Address Line 1"
                              >Address Line 1 <span style="color: red">*</span></label
                            >
                          <b-form-input autocomplete="off" v-model="form1.addresses.residential.address_line1" required />
                          </b-form-group>
                      </div>

                      <div class="col-md-6">
                          <b-form-group>
                            <label for="Address Line 2"
                              >Address Line 2 <span style="color: red">*</span></label
                            >
                          <b-form-input autocomplete="off" v-model="form1.addresses.residential.address_line2" />
                          </b-form-group>
                      </div>

                      <div class="col-md-6">
                          <b-form-group>
                            <label for="City"
                              >City <span style="color: red">*</span></label
                            >
                          <b-form-input autocomplete="off" @keypress="allowOnlyText" v-model="form1.addresses.residential.city" required />
                          </b-form-group>
                      </div>

                      <div class="col-md-6">
                          <b-form-group>
                            <label for="State"
                              >State <span style="color: red">*</span></label
                            >
                          <b-form-input autocomplete="off" @keypress="allowOnlyText" v-model="form1.addresses.residential.state" required />
                          </b-form-group>
                      </div>

                      <div class="col-md-4">
                          <b-form-group>
                            <label for="Postal Code"
                              >Postal Code <span style="color: red">*</span></label
                            >
                          <b-form-input autocomplete="off" @keypress="allowOnlyNumbers" v-model="form1.addresses.residential.postal_code" required :maxlength="6" />
                          </b-form-group>
                      </div>

                      <!-- <div class="col-md-4">
                          <b-form-group label="Country *">
                          <b-form-input
                              v-model="form1.addresses.residential.country"
                              required
                              placeholder="IN / india"
                          />
                          </b-form-group>
                      </div> -->

                      <!-- KYC -->
                      <div class="col-12 mt-4 mb-2">
                          <h5 class="section-title">KYC Information</h5>
                      </div>

                      <div class="col-md-6">
                          <b-form-group>
                            <label for="PAN Number"
                              >Owner PAN Number <span style="color: red">*</span></label
                            >
                          <b-form-input
                              autocomplete="off"
                              v-model="form1.kyc.owner_pan"
                              placeholder="ABCDE1234F"
                              :maxlength="10"
                          />
                          </b-form-group>
                      </div>

                      <!-- NOTES -->
                      <!-- <div class="col-12 mt-4 mb-2 d-flex justify-content-between">
                          <h5 class="section-title">Notes (Optional)</h5>
                          <b-button size="sm" variant="success" @click="addNote">
                          + Add Note
                          </b-button>
                      </div> -->

                      <!-- <div class="col-12" v-for="(note, index) in form1.notes" :key="index">
                          <div class="row align-items-center mb-2">
                          <div class="col-md-5">
                              <b-form-input v-model="note.key" placeholder="Key" />
                          </div>
                          <div class="col-md-5">
                              <b-form-input v-model="note.value" placeholder="Value" />
                          </div>
                          <div class="col-md-2 text-right">
                              <b-button variant="danger" size="sm" @click="removeNote(index)">
                              Remove
                              </b-button>
                          </div>
                          </div>
                      </div> -->

                      </div>

                      <!-- ACTION BUTTONS -->
                      <div class="d-flex justify-content-end mt-3">
                      <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('update-stakeholder-modal')">
                          Cancel
                      </b-button>
                      <b-button variant="primary" @click="updateStakeholder">
                          Update Stakeholder
                      </b-button>
                      </div>

                  <!-- </b-form> -->
              </b-modal>

              <b-modal id="updateProductConfigModal" title="Update Settlement Settings" size="lg" hide-footer>
                  <div class="container-fluid">
                      <div class="row">

                      <!-- Section Title -->
                      <div class="col-12 mb-3">
                          <h5 class="section-title">Settlement Settings</h5>
                      </div>

                      <!-- Account Number -->
                      <div class="col-md-6 mb-3">
                          <label>Account Number <span class="text-danger">*</span></label>
                          <b-form-input 
                          autocomplete="off"
                          @keypress="allowOnlyNumbers"
                          v-model="form2.active_configuration.settlements.account_number" 
                          placeholder="Enter bank account number"
                          required
                          />
                      </div>

                      <!-- IFSC Code -->
                      <div class="col-md-6 mb-3">
                          <label>IFSC Code <span class="text-danger">*</span></label>
                          <b-form-input
                          autocomplete="off" 
                          v-model="form2.active_configuration.settlements.ifsc_code" 
                          placeholder="Enter IFSC code"
                          required
                          />
                      </div>

                      <!-- Beneficiary Name -->
                      <div class="col-md-12 mb-3">
                          <label>Beneficiary Name <span class="text-danger">*</span></label>
                          <b-form-input 
                          autocomplete="off"
                          v-model="form2.active_configuration.settlements.beneficiary_name" 
                          placeholder="Enter beneficiary name"
                          required
                          />
                      </div>

                      <!-- T&C -->
                      <div class="col-md-12 mb-3">
                          <b-form-checkbox 
                          v-model="form2.tnc.accepted"
                          :value="true"
                          >
                          I accept the Terms & Conditions
                          </b-form-checkbox>
                      </div>

                      <!-- Submit Button -->
                      <div class="col-12 text-right mt-3">
                          <b-button variant="primary" @click="submitProductConfig">
                          Update Configuration
                          </b-button>
                      </div>

                      </div>
                  </div>
              </b-modal>


            </div>
            <template v-if="tableData.total_pages > 0">
              <div class="data_paginate mt-2">
                <div class="dataTables_paginate paging_simple_numbers d-flex justify-content-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" first-number last-number :total-rows="tableData.total"
                      :total-pages="tableData.total_pages" :per-page="tableData.per_page"></b-pagination>
                  </ul>
                </div>
                <div class="form-inline navbar-search">
                  <span class="mr-2">Go to a Particular Paginated Page :</span>
                  <div class="input-group">
                    <b-form-input id="case" v-model="pageNo" placeholder="Enter Page No" class="in-width">
                    </b-form-input>
                    <div class="input-group-append">
                      <button class="btn btn-search" @click="filterPage">
                        <i class="fas fa-search fa-sm"> </i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.disabled-link {
  pointer-events: none;
  opacity: 0.5;
}
</style>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import MixinRequest from "../../../mixins/request";
import DietPlanMixin from "../../../mixins/ModuleJs/razorpay-vendor";

export default {
  data() {
    return {
      title: "Razorpay Vendor",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "List",
        },
      ],
    };
  },
  mixins: [MixinRequest, DietPlanMixin],
  components: {
    Layout,
    PageHeader,
  },
};
</script>